<script setup>
const config = useRuntimeConfig();
const props = defineProps({
  text: String,
  textColor: String,
  bgColor: String,
  bgGradient: String,
  textPosition: String,
  image: Object,
  imagePositionLeft: String,
  imagePositionRight: String,
  imageHasBorder: Boolean,
  button: Object,
});
</script>

<template>
  <div
    :style="[bgColor ? { backgroundColor: bgColor } : {}]"
    :class="[(bgColor || bgGradient) ? '' : 'mb-xl']"
  >
    <div
      class="flex flex-wrap mb-xl last:mb-0 px-md lg:px-lg xl:px-xl"
      :class="[
        textPosition === 'left'
          ? 'flex-col-reverse md:flex-row'
          : 'flex-col-reverse md:flex-row-reverse',
        imagePositionLeft === 'leftBottom' ||
        imagePositionRight === 'rightBottom'
          ? ''
          : 'items-center',
        bgColor || bgGradient ? 'py-xl' : '',
      ]"
      :style="[bgGradient ? { background: bgGradient } : {}]"
    >
      <div
        class="w-full md:w-1/2"
        :class="
          imagePositionLeft === 'leftBottom' ||
          imagePositionRight === 'rightBottom'
            ? 'md:mt-xl'
            : ''
        "
      >
        <div
          v-html="text"
          class="prose"
          :class="textColor === 'dark' ? 'prose--black' : ''"
        ></div>
        <div v-if="button.text && button.url" :class="text ? 'mt-xl' : ''">
          <Button
            type="link"
            :href="
              button.type === 'linkInternal'
                ? config.public.appBaseUrl + button.url
                : button.url
            "
            :text="button.text"
            :target="button.target"
            :icon="true"
            :aria-label="button.ariaLabel"
            :color="button.color"
            icon-position="right"
          />
        </div>
      </div>
      <div
        class="w-full md:w-1/2 mb-lg md:mb-0"
        :class="[
          textPosition === 'left' && imagePositionRight === 'default'
            ? 'md:pl-lg lg:pl-xl xl:pl-2xl'
            : '',
          textPosition === 'right' && imagePositionLeft === 'default'
            ? 'md:pr-lg lg:pr-xl xl:pr-2xl'
            : '',
          imagePositionLeft === 'leftBottom' ||
          imagePositionRight === 'rightBottom'
            ? 'flex flex-wrap items-end'
            : '',
        ]"
      >
        <div
          v-if="image"
          class="relative mx-auto"
          :class="
            imagePositionLeft === 'leftBottom' ||
            imagePositionLeft === 'rightBottom'
              ? 'max-w-[600px]'
              : ''
          "
        >
          <div v-if="imageHasBorder" class="absolute inset-0 rounded-full z-0">
            <div
              class="absolute w-[84%] h-[84%] m-[8%] rounded-full bg-white"
            ></div>
          </div>
          <picture v-if="image" class="relative z-1">
            <source
              v-if="image.type !== 'svg' && image?.url?.webp"
              :srcset="image?.url?.webp"
              type="image/webp"
            />
            <source
              v-if="
                image.type !== 'svg' && image.type !== 'png' && image?.url?.jpg
              "
              :srcset="image?.url?.jpg"
              type="image/jpeg"
            />
            <img
              v-if="image.type === 'jpg' && image?.url?.jpg"
              :class="[
                textPosition === 'right' && imagePositionLeft === 'leftBottom'
                  ? 'relative -left-[20px] lg:-left-[30px] xl:-left-[45px] md:-bottom-[45px]'
                  : '',
                textPosition === 'left' && imagePositionRight === 'rightBottom'
                  ? 'relative -right-[20px] lg:-right-[30px] xl:-right-[45px] md:-bottom-[45px]'
                  : '',
              ]"
              :src="image?.url?.jpg"
              :alt="image?.alt"
              :title="image?.title"
            />
            <img
              v-else-if="image.type === 'png' && image?.url?.png"
              :class="[
                textPosition === 'right' && imagePositionLeft === 'leftBottom'
                  ? 'relative -left-[20px] lg:-left-[30px] xl:-left-[45px] md:-bottom-[45px]'
                  : '',
                textPosition === 'left' && imagePositionRight === 'rightBottom'
                  ? 'relative -right-[20px] lg:-right-[30px] xl:-right-[45px] md:-bottom-[45px]'
                  : '',
              ]"
              :src="image?.url?.png"
              :alt="image?.alt"
              :title="image?.title"
            />
            <img
              v-else
              :class="[
                textPosition === 'right' && imagePositionLeft === 'leftBottom'
                  ? 'relative -left-[20px] lg:-left-[30px] xl:-left-[45px] md:-bottom-[45px]'
                  : '',
                textPosition === 'left' && imagePositionRight === 'rightBottom'
                  ? 'relative -right-[20px] lg:-right-[30px] xl:-right-[45px] md:-bottom-[45px]'
                  : '',
              ]"
              :src="image?.url?.original"
              :alt="image?.alt"
              :title="image?.title"
            />
          </picture>
        </div>
      </div>
    </div>
  </div>
</template>

<style></style>
